// import React, { useEffect, useState } from 'react'
// import css from '../css/profile.css'
// import profile from '../image/profile.png'
// import { useGetLoggedUserQuery } from '../rtkq/services/userAuthApi'
// import { getToken } from '../rtkq/services/localStorageService'


// const Profile = () => {

// const {access_token} = getToken()
// // console.log(access_token);
// const {data, isSuccess} = useGetLoggedUserQuery(access_token)
// console.log(data);
// const [userData, setUserData] = useState({
//   role: "",
//   email:"",
//   full_name:"",
// })

// useEffect(()=>{
//   console.log(data);
//   if(data && isSuccess){
//     setUserData({
//       role: data.role,
//       full_name: `${data.first_name} ${data.last_name}`,
//       email: data.email,
//     })
//   }
// },[data,isSuccess])

//   return (
//     <>
//         <div className='main-container'>
//         <div className='profile-container'>
//             <div className='inner-container '>
//             <h3 className='person'>Personal Information</h3>
//             <div className='img-div'>
//             <img className='frofile-img' src={profile} alt="Profile-image" />
//             </div>
//             <div>
//             <label htmlFor="" className='block'>Role type:</label>
//             <input className='' type="text" name="" value={userData.role} disabled id="" />
//             </div>

//             <div>
//             <label htmlFor="" className='block'>Full name</label>
//             <input className='' type="text" name="" value={userData.full_name} disabled id="" />
//             </div>
            
//             <div>
//             <label htmlFor="" className='block'>Email Address</label>
//             <input className='' type="text" name="" value={userData.email} disabled id="" />
//             </div>
            
//             </div>

//         </div>
//         </div>
//     </>
//   )
// }

// export default Profile;

import React, { useEffect, useState } from 'react'
import '../css/profile.css'
import profile from '../image/profile.png'
import { useGetLoggedUserQuery } from '../rtkq/services/userAuthApi'
import { getToken } from '../rtkq/services/localStorageService'

const Profile = () => {
  const { access_token } = getToken()
  const { data, isSuccess, isLoading } = useGetLoggedUserQuery(access_token)
  
  const [userData, setUserData] = useState({
    role: "",
    email: "",
    full_name: "",
    class_name: "",
    school_name: "Not specified"
  })

  useEffect(() => {
    if (data && isSuccess) {
      setUserData({
        role: data.role ? data.role.charAt(0).toUpperCase() + data.role.slice(1) : "Not specified",
        full_name: `${data.first_name || ""} ${data.last_name || ""}`.trim() || "Not specified",
        email: data.email || "Not specified",
        class_name: data.class_name || "Not specified",
        school_name: data.school_name || "Not specified"
      })
    }
  }, [data, isSuccess])

  // Determine user type for styling
  const userTypeClass = userData.role.toLowerCase() === "student" ? "student-profile" : "other-profile";

  return (
    <div className='profile-page-container'>
      <div className={`profile-card ${userTypeClass}`}>
        {isLoading ? (
          <div className="profile-loader">
            <div className="loader-spinner"></div>
            <p>Loading profile...</p>
          </div>
        ) : (
          <>
            <div className='profile-header'>
              <h2>Personal Information</h2>
              <div className='profile-image-container'>
                <img className='profile-image' src={profile} alt={`${userData.full_name}'s profile`} />
              </div>
            </div>
            
            <div className='profile-content'>
              <div className='profile-field'>
                <label>Role</label>
                <div className='profile-value role-badge'>{userData.role}</div>
              </div>

              <div className='profile-field'>
                <label>Full Name</label>
                <div className='profile-value'>{userData.full_name}</div>
              </div>
              
              <div className='profile-field'>
                <label>Email Address</label>
                <div className='profile-value'>{userData.email}</div>
              </div>
              
              {userData.class_name && (
                <div className='profile-field'>
                  <label>Class</label>
                  <div className='profile-value'>{userData.class_name}</div>
                </div>
              )}
              
              {userData.school_name && userData.school_name !== "Not specified" && (
                <div className='profile-field'>
                  <label>School</label>
                  <div className='profile-value'>{userData.school_name}</div>
                </div>
              )}
            </div>
            
            <div className='profile-footer'>
              <p>Member since {new Date().getFullYear()}</p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Profile;
